var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.labelIconPosition") } },
    [
      _c(
        "el-select",
        {
          model: {
            value: _vm.optionModel.labelIconPosition,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "labelIconPosition", $$v)
            },
            expression: "optionModel.labelIconPosition",
          },
        },
        _vm._l(_vm.labelIconPosition, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }